<template>
  <div class="import-tool">
    <Modal v-model="visible" title="批量导入" :mask-closable="false" width="550" :footer-hide="true" class="my-modal top import-tool-modal2">
      <div class="box">
        <p class="text1">操作步骤：</p>
        <p class="text2">1、下载模板excel，根据模板字段批量填充数据。</p>
        <p class="text2">2、点击“上传excel”，将整理好的excel上传，请不要修改任何表头数据。</p>
        <p class="text2">3、如果存在异常数据，系统会直接导入正常数据，并自动下载异常数据excel，您可根据异常原因修改后重新上传excel。</p>
        <p class="text2">4、合同影像件支持多选文件批量上传，最多50个，每个文件大小不超过50M，文件类型仅支持PDF文件，上传时合同影像件请以 "<span class="strong">合同编码_合同名称</span>" 命名。（合同影像文件命名示例：0001_入职合同.pdf）</p>
      </div>
      <div class="ivu-modal-footer">
        <Button type="primary" ghost @click="visible=false">取消</Button>
        <Button type="primary" @click="download"><i class="iconfont icondaoru1"></i>下载模板</Button>
        <Upload 
          ref="upload" 
          v-if="data.uploadUrl" 
          :show-upload-list="false" 
          class="upload-btn" 
          :max-size="2048" 
          :before-upload="handleBeforeUpload"
          :action="data.uploadUrl"
        >
          <Button type="primary" :loading="uploadExcelLoading">
            <i class="iconfont icondaochu" v-if="!uploadExcelLoading"></i>
            上传excel
          </Button>
        </Upload>      
        <Button class="upload-image" type="primary" @click="uploadImage"><i class="iconfont icondaochu"></i>上传合同影像</Button>
      </div>
    </Modal>

    <multipleUploadFile ref="uploadFile" @success="$emit('success')"></multipleUploadFile>
  </div>
</template>
<script>
import multipleUploadFile from './multipleUploadFile';
export default {
  components: {
    multipleUploadFile
  },
  
  data() {
    return {
      columns:[
        {
          title: "行号",
          key: 'row',
          width: 100,
          align: 'center'
        },
        {
          title: "错误原因",
          key: "content",
          align: 'center',
          minWidth: 100,
        }
      ],
      fileFormat:['xls','xlsx', 'XLS', 'XLSX'],
      visible:false,
      data:{},
      uploadExcelLoading: false
    };
  },

  methods: {
    open(data={}){
      this.data = data;
      this.visible = true;
    },

    // 下载模板
    download(){
      this.$http({
        url: "/system/dic/read/dicList",
        type: "POST",
        data: {
          code: "USER_CONTRACT_EXPORT",
        },
      }).then((res) => {
        const url = res.data[0].value;
        const fileName = res.data[0].txt;
        this.getBlob(url).then(blob => {
          this.saveAs(blob, fileName);
        })
      });
    },
    // 将url转成blob文件
    getBlob(url) {
      return new Promise(resolve => {
        const xhr = new XMLHttpRequest()
        xhr.open('GET', url, true)
        xhr.responseType = 'blob'
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response)
          }
        }
        xhr.send()
      })
    },
    //下载文件 　　js模拟点击a标签进行下载
    saveAs(blob, filename) {
      var link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
    },

    handleBeforeUpload(file){
      const format = file.name.split("\.")[1];
      if(!this.fileFormat.includes(format)){
        this.$notice.msg("请上传"+this.fileFormat.join(",")+"格式的文件")
        return false;
      }
      this.uploadExcelLoading = true;
      let formData = new FormData();
      formData.append("file", file);
      this.$http({
        type: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        url: this.data.uploadUrl,
        data: formData,
        apiPermissionCode:'org_6_5'
      }).then(res=>{
        const successNum = res.data.successList&&res.data.successList.length;
        const errorNum = res.data.errorList&&res.data.errorList.length;
        let text = `系统已成功导入${successNum}条数据`;
        this.$emit("success");
        if(errorNum){
          text = text+`，存在${errorNum}条数据未导入`;
          if(this.data.errorUrl){
            this.$units.downloadFile(this.data.errorUrl, {
              errorList: res.data.errorList
            },"POST")
          }
          this.$notice.error(text)
        }else{
          this.visible = false;
          this.$notice.success(text);
        }
        this.uploadExcelLoading = false; 
      }).catch(error =>{
        this.uploadExcelLoading = false;
      })
      return false;
    },

    uploadImage() {
      this.$refs.uploadFile.open();
    }
  },
};
</script>
<style lang="scss" scoped>
.import-tool-modal2 /deep/ {
  .ivu-modal-header-inner{
    font-size: 14px;
    font-weight: bold;
    color: #3C464F;
  }
  .ivu-modal-close{
    top: 4px ;
    .ivu-icon-ios-close {
      font-size: 30px;
      color: #A8ADB7;
    }
  }
  .ivu-modal-header{
    padding: 0 20px;
    height: 40px;
    line-height: 40px;
  }
  .box {
    padding-top: 15px;
    padding-bottom: 10px;
    font-size: 12px;
    .text1 {
      color: #515C6F;
      margin-bottom: 15px;
    }
    .text2 {
      margin-bottom: 10px;
      .strong {
        color: red;
        font-weight: bold;
      }
    }
  }
  .ivu-modal-footer {
    border-top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 30px;
    .iconfont {
      font-size: 14px;
      margin-right: 4px;
    }
    .upload-btn {
      margin-left: 10px;
    }
    button + button {
      margin-left: 10px;
    }
  }
  .upload-image {
    width: 120px;
    margin-left: 10px;
  }
}
</style>
